export default __webpack_public_path__ + "static/media/meal-black.74c2683d.png";